/**
 * 课程表单的共享业务逻辑
 * @param {Object} initialData - 初始数据（编辑模式使用）
 * @returns {Object} 表单状态和方法
 */
export const useCourseForm = (initialData = {}) => {
  // 课程状态选项（与后端模型一致）
  const statusOptions = ["可用", "下线"];

  return {
    statusOptions,
  };
};
